export default __webpack_public_path__ + "static/media/4eyp-logo.da0b7984.png";